<template>
  <div>
    <a-descriptions>
      <a-descriptions-item style="text-align: center">
        <div>
          {{ Copyright }}
        </div>
    </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { footerCopyright } from '@/utils/theme'
export default {
  data() {
    return {
      Copyright: ''
    }
  },
  mounted() {
    this.Copyright =  footerCopyright[this.$store.state.style+'FooterCopyright']
  },
  watch: {
    '$store.state.style'(val){
      this.Copyright = footerCopyright[val+'FooterCopyright'];
	  },
  }
};
</script>

<style scoped>
  .ant-descriptions >>> div {
    color: rgba(0, 0, 0, 0.45);
    text-align: center;
    font-family: PingFangSC-Regular;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
  }
</style>
